import { __awaiter, __generator } from "tslib";
import { ERR_INVALID_ARGUMENT, ERR_INVALID_STATE, newError } from "../../utils/error";
/**
 * Helper class for PricingProcedure handling.
 */
var PricingProcedureInfo = /** @class */ (function () {
    function PricingProcedureInfo(pProc, pTypes) {
        this.mProcedure = pProc;
        //build condition types map
        this.mTypes = new Map();
        for (var _i = 0, pTypes_1 = pTypes; _i < pTypes_1.length; _i++) {
            var tType = pTypes_1[_i];
            this.mTypes.set(tType.name, tType);
        }
        //build line and tags map
        this.mLines = new Map();
        this.mLineTags = new Map();
        for (var _a = 0, _b = this.mProcedure.lines; _a < _b.length; _a++) {
            var tLine = _b[_a];
            //line map
            var tKey = tLine.level.toString() + "_" + tLine.counter.toString();
            this.mLines.set(tKey, tLine);
            //tag map
            var tTags = new Set();
            if (tLine.tags != null) {
                for (var _c = 0, _d = tLine.tags; _c < _d.length; _c++) {
                    var tTag = _d[_c];
                    tTags.add(tTag);
                }
            }
            this.mLineTags.set(tLine, tTags);
        }
    }
    Object.defineProperty(PricingProcedureInfo.prototype, "name", {
        get: function () {
            return (this.mProcedure.name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PricingProcedureInfo.prototype, "procedure", {
        get: function () {
            return (this.mProcedure);
        },
        enumerable: false,
        configurable: true
    });
    PricingProcedureInfo.prototype.getConditionType = function (pConditionName) {
        return (this.mTypes.get(pConditionName));
    };
    /**
     * Returns the PricingProcedureLine for the given line level and counter. If the line
     * doesn't exist and pFallbackToDefaultCounter is true, the default counter (0) will be used
     * as a fallback.
     */
    PricingProcedureInfo.prototype.getProcedureLine = function (pLevel, pCounter, pFallbackToDefaultCounter) {
        if (pFallbackToDefaultCounter === void 0) { pFallbackToDefaultCounter = true; }
        var tKey = pLevel.toString() + "_" + pCounter.toString();
        var tLine = this.mLines.get(tKey);
        if (pFallbackToDefaultCounter && tLine == undefined && pCounter !== 0)
            return (this.getProcedureLine(pLevel, 0, false));
        return (tLine);
    };
    /**
     * Returns the tags of a PricingProcedureLine as Set which is cached internally.
     */
    PricingProcedureInfo.prototype.getLineTags = function (pLine) {
        var tTags = this.mLineTags.get(pLine);
        if (tTags == null)
            throw newError(ERR_INVALID_ARGUMENT, "unknown pricing procedure line");
        return (tTags);
    };
    PricingProcedureInfo.CreateInfo = function (pSession, pPricingProcedureName, pUseActiveProcedure) {
        if (pUseActiveProcedure === void 0) { pUseActiveProcedure = true; }
        return __awaiter(this, void 0, void 0, function () {
            var tProc, tTypes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!pSession.isValid)
                            throw newError(ERR_INVALID_STATE, "session not valid");
                        return [4 /*yield*/, pSession.basket.getPricingProcedure(pUseActiveProcedure, pPricingProcedureName)];
                    case 1:
                        tProc = _a.sent();
                        return [4 /*yield*/, pSession.basket.getConditionTypes(pUseActiveProcedure, pPricingProcedureName)];
                    case 2:
                        tTypes = _a.sent();
                        return [2 /*return*/, (new PricingProcedureInfo(tProc, tTypes))];
                }
            });
        });
    };
    return PricingProcedureInfo;
}());
export { PricingProcedureInfo };
